/**
 * Custom JavaScript for the Kiosk Homepage
 *
 * Sets a cookie for the referral code to be handled in the kiosk.
 */

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const scaRef = getQueryParam("sca_ref");

if (scaRef) {
  setCookie("mm_sca_ref", scaRef, 365); // Cookie expires in 365 days
}
